/* GGC cover quiz behaviour. Reads its data from the #ggc-quiz-data JSON block. */
(function(){
  var root = document.querySelector('.gcq');
  var dataEl = document.getElementById('ggc-quiz-data');
  if(!root || !dataEl) return;
  /* all the Liquid values arrive in one JSON block so this can be a cached asset */
  var D = JSON.parse(dataEl.textContent);

  /* One cover list per page. When this section carries no cover blocks it reads the hero's,
     which the hero publishes as window.DYBL.covers. Its own blocks still win when present,
     so the quiz also works on a page with no DYBL hero. */
  var COVERS = (D.covers && D.covers.length) ? D.covers : ((window.DYBL && window.DYBL.covers) || []).map(function(c){
    return { name:c.name, title:c.persona, desc:c.blurb || c.line, mystery:!!c.mystery,
             img:c.img, mini:c.img, vid:c.vid, price:c.price, available:c.available };
  });
  if(!COVERS.length) return;

  var QUESTIONS = D.questions;

  var TXT = D.txt;

  /* an empty question block would leave an empty answers list, which is just skipped */
  QUESTIONS = QUESTIONS.filter(function(q){ return q.q && q.answers.length; });

  var byName = {};
  COVERS.forEach(function(c){ byName[c.name.trim().toLowerCase()] = c; });
  var mystery = COVERS.filter(function(c){ return c.mystery; })[0] || null;
  /* a mystery cover is never a quiz outcome: it is only reachable through "Surprise me" */
  var POOL = COVERS.filter(function(c){ return !c.mystery; });

  var screens = {
    start:  root.querySelector('[data-screen="start"]'),
    quiz:   root.querySelector('[data-screen="quiz"]'),
    result: root.querySelector('[data-screen="result"]')
  };
  function show(which){
    Object.keys(screens).forEach(function(k){ if(screens[k]) screens[k].hidden = (k !== which); });
  }

  var step = 0;
  var picks = [];           /* answer index chosen per question */

  function render(){
    var q = QUESTIONS[step];
    if(!q) return;
    root.querySelector('[data-step]').textContent = (step + 1) + ' / ' + QUESTIONS.length;
    root.querySelector('[data-fill]').style.width = (((step) / QUESTIONS.length) * 100) + '%';
    root.querySelector('[data-q]').textContent = q.q;

    var wrap = root.querySelector('[data-opts]');
    wrap.innerHTML = '';
    q.answers.forEach(function(a, i){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'opt';
      b.textContent = a.text;
      b.setAttribute('aria-pressed', picks[step] === i ? 'true' : 'false');
      b.addEventListener('click', function(){ choose(i); });
      wrap.appendChild(b);
    });
    root.querySelector('[data-back]').style.visibility = step === 0 ? 'hidden' : 'visible';
  }

  function choose(i){
    picks[step] = i;
    if(step < QUESTIONS.length - 1){ step++; render(); }
    else finish();
  }

  function parseCovers(str){
    return String(str || '').split(',').map(function(x){ return x.trim().toLowerCase(); })
      .filter(Boolean);
  }

  function score(){
    var tally = {}, firstSeen = {};
    POOL.forEach(function(c){ tally[c.name] = 0; });
    QUESTIONS.forEach(function(q, qi){
      var a = q.answers[picks[qi]];
      if(!a) return;
      var w = Number(q.weight) || 1;
      parseCovers(a.covers).forEach(function(key){
        var c = byName[key];
        if(!c || c.mystery) return;          /* unknown name, or the mystery cover: ignore */
        tally[c.name] = (tally[c.name] || 0) + w;
        if(firstSeen[c.name] === undefined) firstSeen[c.name] = qi;
      });
    });
    var best = null;
    POOL.forEach(function(c){
      var t = tally[c.name] || 0;
      if(!best){ best = c; return; }
      var bt = tally[best.name] || 0;
      if(t > bt) { best = c; return; }
      /* a tie goes to whichever was scored earliest, so the first answer decides */
      if(t === bt){
        var fa = firstSeen[c.name], fb = firstSeen[best.name];
        if(fa !== undefined && (fb === undefined || fa < fb)) best = c;
      }
    });
    return best;
  }

  function shotHtml(c, secret){
    if(secret){
      return '<div class="shot secret"><span class="secret-mark">' + esc(TXT.secretMark) + '</span>' +
             '<span class="shot-note" style="font-family:\'DM Mono\',monospace;text-transform:uppercase;' +
             'letter-spacing:.14em;font-size:10.5px;color:var(--taupe);text-align:center;line-height:1.5;">' +
             esc(TXT.secretNote) + '</span></div>';
    }
    if(c.img) return '<div class="shot"><img src="' + c.img + '" alt="' + esc(c.name) + '"></div>';
    return '<div class="shot ph">' + esc(TXT.noShotNote) + '</div>';
  }

  function esc(t){
    return String(t == null ? '' : t).replace(/[&<>"']/g, function(ch){
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[ch];
    });
  }

  var current = null;

  function present(c, isSurprise){
    current = c;
    var secret = !!c.mystery;
    root.querySelector('[data-shot]').innerHTML = shotHtml(c, secret);
    root.querySelector('[data-kicker]').textContent = isSurprise ? TXT.surpriseKicker : TXT.matchKicker;
    root.querySelector('[data-name]').textContent = c.name;
    root.querySelector('[data-title]').textContent = c.title || '';
    root.querySelector('[data-desc]').textContent = c.desc || '';

    var priceEl = root.querySelector('[data-price]');
    if(c.price){ priceEl.innerHTML = c.price; priceEl.hidden = false; } else { priceEl.hidden = true; }

    var add = root.querySelector('[data-add]');
    if(c.vid && c.available){ add.textContent = TXT.addLabel; add.disabled = false; }
    else if(c.vid && !c.available){ add.textContent = TXT.soldOutLabel; add.disabled = true; }
    else { add.textContent = TXT.pickLabel; add.disabled = false; }

    buildAll(c);
    root.querySelector('[data-fill]').style.width = '100%';
    show('result');
    try {
      /* lets the rest of the PDP react, e.g. swap the gallery to this cover */
      document.dispatchEvent(new CustomEvent('ggc:cover-selected', {
        bubbles: true, detail: { name: c.name, variantId: c.vid, mystery: secret }
      }));
    } catch(e){}
    syncVariantInputs(c);
    root.scrollIntoView({ behavior:'smooth', block:'start' });
  }

  /* point any product form on the page at the chosen cover, so the buy box agrees
     with the quiz result */
  function syncVariantInputs(c){
    if(!c.vid) return;
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]')
      .forEach(function(inp){
        inp.value = c.vid;
        try { inp.dispatchEvent(new Event('change', { bubbles:true })); } catch(e){}
      });
  }

  function buildAll(c){
    var row = root.querySelector('[data-allrow]');
    if(!row) return;
    row.innerHTML = '';
    COVERS.forEach(function(x){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mini';
      if(x.name === c.name) b.setAttribute('aria-current','true');
      var box = document.createElement('span');
      box.className = 'box';
      if(x.mystery){
        box.className = 'box is-secret';
      } else if(x.mini){
        var im = document.createElement('img');
        im.src = x.mini; im.alt = ''; im.loading = 'lazy';
        box.appendChild(im);
      }
      var lab = document.createElement('span');
      lab.textContent = x.name;
      b.appendChild(box); b.appendChild(lab);
      b.addEventListener('click', function(){ present(x, !!x.mystery); });
      row.appendChild(b);
    });
  }

  function addToCart(){
    var c = current;
    if(!c) return;
    if(!c.vid){
      var buy = document.querySelector('form[action*="/cart/add"]');
      if(buy) buy.scrollIntoView({ behavior:'smooth', block:'center' });
      return;
    }
    var btn = root.querySelector('[data-add]');
    if(btn.getAttribute('data-busy')) return;
    var label = btn.textContent;
    btn.setAttribute('data-busy','1'); btn.disabled = true; btn.textContent = TXT.addingLabel;
    var restore = function(){ btn.removeAttribute('data-busy'); btn.disabled = false; btn.textContent = label; };
    var body = new FormData();
    body.append('id', c.vid);
    body.append('quantity', '1');
    /* fetch, never a native POST: Qikify patches window.fetch and opens its drawer on
       /cart/add.js. A form POST would navigate to /cart and skip the drawer. */
    fetch('/cart/add.js', { method:'POST', headers:{ 'Accept':'application/json' }, body: body })
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){
        restore();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles:true }));
      })
      .catch(function(){ restore(); window.location.href = '/cart'; });
  }

  function finish(){ var b = score(); if(b) present(b, false); }

  function surprise(){
    if(mystery) present(mystery, true);
    else if(POOL.length) present(POOL[Math.floor(Math.random() * POOL.length)], true);
  }

  function start(){ step = 0; picks = []; render(); show('quiz'); }

  root.querySelector('[data-start]').addEventListener('click', start);
  root.querySelector('[data-again]').addEventListener('click', start);
  root.querySelector('[data-add]').addEventListener('click', addToCart);
  root.querySelector('[data-back]').addEventListener('click', function(){
    if(step > 0){ step--; render(); }
  });
  root.querySelectorAll('[data-surprise]').forEach(function(b){ b.addEventListener('click', surprise); });

  /* expose for the rest of the PDP and for debugging */
  window.GGCCoverQuiz = { covers: COVERS, questions: QUESTIONS, result: function(){ return current; } };
})();